<div [ngSwitch]="column().type">
  <app-status-column
    *ngSwitchCase="ColumnType.STATUS"
    [config]="column().columnConfig"
    [value]="row()[column().id]"
  >
  </app-status-column>
  <span *ngSwitchCase="ColumnType.CURRENCY">
    {{ row()[column().id] | currency : "BRL" : "R$" | emptyValue }}
  </span>
  <span *ngSwitchCase="ColumnType.DATE">
    {{ row()[column().id] | date : "dd/MM/yyyy" | emptyValue }}
  </span>
  <app-boolean-column
  *ngSwitchCase="ColumnType.BOOLEAN"
  [value]="row()[column().id]"
  [markable]="column().markable" 
  (valueChange)="onBooleanChange($event)"
>
</app-boolean-column>
  <span *ngSwitchCase="ColumnType.MASK">
    {{ row()[column().id] | mask : column().mask | emptyValue }}
  </span>
  <span
    *ngSwitchCase="ColumnType.NAME"
    matTooltip="{{ row()[column().id] }}"
    matTooltipPosition="above"
  >
    {{ row()[column().id] | truncate : 30 | emptyValue }}
  </span>

  <span
    *ngSwitchCase="ColumnType.SELECT_DATA"
    matTooltip="{{ row()[column().id]?.label }}"
  >
    {{
      row()[column().id]?.label
        ? (row()[column().id]?.label | truncate : 30)
        : (row()[column().id] | truncate : 30 | emptyValue)
    }}
  </span>

  <span *ngSwitchCase="ColumnType.CPF_CNPJ">
    {{
      row()[column().id]
        | mask
          : (row()[column().id]?.length === CPF_SIZE
              ? CPF_MASK
              : (CNPJ_MASK | emptyValue))
    }}
  </span>
  <ng-container *ngSwitchCase="ColumnType.COMPONENT" #dynamicComponentContainer>
  </ng-container>
  <span class="default-string" *ngSwitchDefault>
    {{ row()[column().id] | emptyValue }}
  </span>
</div>
